import type { Footer } from './footer';

export const footerData: Footer = {
  aceFooterLogo: [
    {
      typeHandle: 'logo',
      logoLink: 'https://hospitality.aceable.com/',
      logoImage: [
        {
          url: 'https://xgrit-ecom.imgix.net/v3_images/Hospitality/hsp-logo.png?v=1793211741&auto=compress',
          altText: 'Aceable Hospitality Logo (Footer)',
        },
      ],
    },
  ],
  aceGeneralLinkGroup: [
    {
      typeHandle: 'link',
      linkUrl: '/support/',
      linkText: 'Help Center',
      newTab: false,
      nofollow: false,
    },
    {
      typeHandle: 'link',
      linkUrl: '/resources/',
      linkText: 'Blog',
      newTab: false,
      nofollow: false,
    },
  ],
  aceVerticalLinkGroup: [
    {
      typeHandle: 'link',
      linkUrl: 'https://www.aceable.com/driving/',
      linkText: 'Driving',
      newTab: false,
      nofollow: false,
    },
    {
      typeHandle: 'link',
      linkUrl: 'https://www.aceableagent.com/',
      linkText: 'Real Estate',
      newTab: false,
      nofollow: false,
    },
    {
      typeHandle: 'link',
      linkUrl: 'https://insurance.aceable.com/',
      linkText: 'Insurance',
      newTab: false,
      nofollow: false,
    },
    {
      typeHandle: 'link',
      linkUrl: 'https://www.mortgage.aceable.com/',
      linkText: 'Mortgage',
      newTab: false,
      nofollow: false,
    },
    {
      typeHandle: 'link',
      linkUrl: 'https://hospitality.aceable.com/',
      linkText: 'Hospitality',
      newTab: false,
      nofollow: false,
    },
  ],
  aceSocialLinkGroup: [
    {
      typeHandle: 'socialLink',
      linkUrl: 'https://www.instagram.com/aceablehospitality/',
      linkText: 'Instagram',
      newTab: true,
      nofollow: false,
      icon: 'instagram',
    },
    {
      typeHandle: 'socialLink',
      linkUrl: 'https://www.tiktok.com/@aceablehospitality',
      linkText: 'TikTok',
      newTab: true,
      nofollow: false,
      icon: 'tiktok',
    },
    {
      typeHandle: 'socialLink',
      linkUrl: 'https://www.facebook.com/AceableHospitality/',
      linkText: 'Facebook',
      newTab: true,
      nofollow: false,
      icon: 'facebook-square',
    },
    {
      typeHandle: 'socialLink',
      linkUrl: 'https://x.com/acehospitalityx',
      linkText: 'X',
      newTab: true,
      nofollow: false,
      icon: 'x-twitter',
    },
  ],
  bottomLinkGroup: [
    {
      typeHandle: 'link',
      linkText: 'Privacy Policy',
      linkUrl: 'https://hospitality.aceable.com/privacy-policy/',
      nofollow: false,
      newTab: false,
    },
    {
      typeHandle: 'link',
      linkText: 'Terms & Conditions',
      linkUrl: 'https://hospitality.aceable.com/terms-and-conditions/',
      nofollow: false,
      newTab: false,
    },
  ],
  aceShareGroup: [
    {
      label: 'Partner with Us',
      link: 'https://partnerships.aceable.com',
    },
    {
      label: 'Refer a Friend',
      link: '/referral/invite/',
    },
  ],
  aceShowHideFooterNav: true,
  emailCapture: [],
};
